export default "__VITE_ASSET__DXnji3De__"